import { render, staticRenderFns } from "./VoiceRecordingPanel.vue?vue&type=template&id=31c8cbaa&scoped=true"
import script from "./VoiceRecordingPanel.vue?vue&type=script&lang=js"
export * from "./VoiceRecordingPanel.vue?vue&type=script&lang=js"
import style0 from "./VoiceRecordingPanel.vue?vue&type=style&index=0&id=31c8cbaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c8cbaa",
  null
  
)

export default component.exports